import {
  getItemFromCollection,
} from "directus/src/operations";
import client from "directus/src/client";
import { customEndpoint } from "directus/src/operations";

export async function fetchRepoForGithub({ id }) {
  try {
    const query = {
      fields: ["id", "repository_url", "suffix"],
    };
    const response = await getItemFromCollection("git_repositories", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function addEmployeeAccess({ repository_url, employees, permission = "push", role }) {
  try {
    const selectedPermission = permission || role || "push";
    const response = await client.request(
      customEndpoint({
        path: `/github/repository/add_access`,
        method: "POST",
        body: JSON.stringify({
          repository_url,
          employees,
          permission: selectedPermission,
          role: selectedPermission,
        }),
      })
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function updateEmployeeRole({ repository_url, employeeId, permission }) {
  return addEmployeeAccess({
    repository_url,
    employees: [employeeId],
    permission,
  });
}

export async function removeEmployeeAccess({ repository_url, employeeId }) {
  try {
    const query = new URLSearchParams({
      repository_url,
      employee: employeeId,
    }).toString();

    const response = await client.request(
      customEndpoint({
        path: `/github/repository/remove_access?${query}`,
        method: "DELETE",
      })
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
